var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeadset = function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Headset_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Headset_svg__b)",
    fill: "#344054"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.277 12.865a8.11 8.11 0 0 0-.053-3.474 8.2 8.2 0 0 0-1.504-3.147 8.395 8.395 0 0 0-2.69-2.263A8.567 8.567 0 0 0 12.629 3v1.369a7.153 7.153 0 0 1 3.01.967 6.993 6.993 0 0 1 2.274 2.16 6.785 6.785 0 0 1 .752 6.005l-3.99 5.855 4.038 2.641 4.787-7.024-3.223-2.108Zm-1.948 7.241-1.725-1.13 3.242-4.756 1.726 1.133-3.243 4.753ZM4.95 11.249a6.842 6.842 0 0 1 1.85-4.66 7.11 7.11 0 0 1 4.571-2.22V3a8.567 8.567 0 0 0-3.4.98 8.395 8.395 0 0 0-2.69 2.264 8.2 8.2 0 0 0-1.505 3.147 8.112 8.112 0 0 0-.053 3.474L.5 14.976l4.788 7.021 4.037-2.64-3.99-5.856a6.772 6.772 0 0 1-.384-2.252Zm.721 8.86L2.43 15.353l1.721-1.13 3.243 4.756-1.722 1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.797 6.715-3.5 1.965H8.405v4.591h2.894l3.499 1.965V6.715Zm-1.39 6.17-1.74-.977H9.796v-1.865h1.873l1.738-.976v3.817Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Headset_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Headset_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 3)",
    d: "M0 0h23v19H0z"
  })))));
};
export default SvgHeadset;